import { ChristmasOfferLicensesPage } from '../christmas/licenses-page'
import { useCampaigns } from '../state/hooks'
import { Campaigns } from '../state/types'
import type { CampaignLicensesPageProps } from '../types'

// TODO: temporary partial. as the black friday page is missing for now
const licensesPagesMap: Partial<
  Record<Campaigns, React.FC<CampaignLicensesPageProps>>
> = {
  [Campaigns.Christmas]: ChristmasOfferLicensesPage,
}

interface Props extends CampaignLicensesPageProps {
  defaultPageContent: JSX.Element
}

export const LicensesPageContentWithCampaign = ({
  defaultPageContent,
  ...props
}: Props) => {
  const { activeCampaign } = useCampaigns()

  if (!activeCampaign || !licensesPagesMap[activeCampaign]) {
    return defaultPageContent
  }

  const LicensesPageContentComponent = licensesPagesMap[activeCampaign]

  return <LicensesPageContentComponent {...props} />
}
